// extracted by mini-css-extract-plugin
export default {"container":"shippings_container__Dmo19","list":"shippings_list__CxKxB","shipping":"shippings_shipping__mcp8w","reset":"shippings_reset__oBi2h"};